export enum PaymentGatewayCode
{
    ClickAndCollectCash = 'click-and-collect-cash',
    ClickAndCollectCard = 'click-and-collect-card',
    CourierCash = 'courier-cash',
    BankTransfer = 'bank-transfer',
    CardGeneric = 'card-generic',
    CardStripe = 'card-stripe',
    CardEuPlatesc = 'card-eu-platesc',
    CardPaylike = 'card-paylike',
    CardNetopia = 'card-netopia',
    TbiPay = 'tbi-pay'
}